export default __webpack_public_path__ + "static/media/graphql-icon.e335785b.svg";